import axios from 'axios';
import React, { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { getImageUrl } from '../../auth/imagehosting';
import { AuthProvider } from '../../Context/AuthContext';
import SmallSpinner from '../../Shared/Spinner/SmallSpinner';

const PublishCourse = () => {
    const { user } = useContext(AuthProvider)
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()

    const { register, handleSubmit, watch, formState: { errors } } = useForm();
    const onSubmit = (e) => {
        console.log(e)
        const heading = e.heading
        const title = e.Shortname
        const lession = e.lession
        const hours = e.hours
        const fees = e.price
        const image = e.image[0]

        setLoading(true)
        getImageUrl(image)
            .then(imgLink => {
                console.log(imgLink)

                const courseData = {
                    banner: imgLink,
                    lession,
                    heading,
                    hours,
                    fees,
                    title,
                    rating: "35",
                    review: "25",
                    host: user?.photoURL,
                    hostEmail: user?.email,
                    hostName: user?.displayName
                }
                console.log(courseData)
                axios.post(`${process.env.REACT_APP_API_URL}/postacourse`, courseData)
                    .then(res => {
                        console.log(res.data)
                        if (res.data.acknowledged === true) {
                            toast.success("ACourse Posted Successfully")
                            navigate('/dashboard/courses')
                            setLoading(false)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        setLoading(false)
                    })
            })
    }
    return (
        <div className='flex items-center justify-center min-h-screen max-w-md mx-auto'>
            <form onSubmit={handleSubmit(onSubmit)} action="">
                <div class="modal-dialog modal-dialog-centered relative w-auto pointer-events-none">
                    <div class="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current ">
                        <div class="modal-header flex flex-shrink-0 items-center justify-between p-4 border-b border-gray-200 rounded-t-md ">
                            <h5 class="text-xl font-medium leading-normal text-gray-800" id="exampleModalScrollableLabel">
                                Course Info
                            </h5>
                            <button type="button"
                                class="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                                data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body relative p-5">

                            <div>
                                <label for="dropzone-file" class="flex items-center px-3 py-3 mx-auto text-center bg-white border-2 border-dashed rounded-lg cursor-pointer dark:border-gray-600 dark:bg-gray-900 mb-6">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-gray-300 dark:text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                                    </svg>

                                    <h2 class="mx-3 text-gray-400">Course Banner</h2>

                                    <input id="dropzone-file" type="file" class="hidden"
                                        {...register("image")}
                                    />

                                </label>
                                <input type="text" class="block w-full py-3 text-gray-700 bg-white border rounded-lg px-5 mb-3 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40" placeholder="Course Breef Name"
                                    {...register("heading")}
                                />

                                <div className='flex items-center gap-5 mb-3'>
                                    <input type="number" class="block w-full py-3 text-gray-700 bg-white border rounded-lg px-5  dark:bg-gray-900 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40" placeholder="Lessons"
                                        {...register("lession")}
                                    />
                                    <select class="block w-full py-3 text-gray-400 bg-white border rounded-lg 
                                        dark:bg-gray-900 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
                                        {...register("hours")}
                                    >
                                        <option className='pr-5'>Daily Hours</option>
                                        <option value='2'> 2 Hours</option>
                                        <option value='3'>3 Hours</option>
                                        <option value='01:30M'>1.5 Hours</option>
                                    </select>
                                    <input type="text" class="block w-full py-3 text-gray-700 bg-white border rounded-lg px-5 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40" placeholder="Course Price"
                                        {...register("price")}
                                    />
                                </div>
                                <input type="text" class="block w-full py-3 text-gray-700 bg-white border rounded-lg px-5 mb-3 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40" placeholder="Course Title"
                                    {...register("Shortname")}
                                />
                            </div>

                        </div>
                        <div
                            class="modal-footer flex flex-shrink-0 flex-wrap items-center justify-end p-4 border-t border-gray-200 rounded-b-md">
                            <button type="submit"
                                class="inline-block w-32 h-8  bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
                                {
                                    loading ?
                                        <SmallSpinner />
                                        :
                                        "Save And Publish"
                                }
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default PublishCourse;